import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorType';

export class ColorType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
